/*
 * Title:  Rewards/EarnTabContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Earn Content page content listing, click on list to expand.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */
import React from "react";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import EarnContentItem from "@components/Profile/EarnContentItem";
import Loader from "@components/Loader";
import { getHostName } from "@helpers/common";

const animations = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};

type Props = {};
type MyState = {
  open: boolean;
  value: string;
};

const sortBy = (array: any) => {
  const featured = [];
  const twitter = [];
  const partnerships = [];
  const twitch = [];
  const tiktok = [];
  array.forEach(function (v) {
    if (v.touchpoint.touchpoint === "featured") featured.push(v);
    else if (v.touchpoint.touchpoint === "twitter") twitter.push(v);
    else if (v.touchpoint.touchpoint === "partnerships") partnerships.push(v);
    else if (v.touchpoint.touchpoint === "twitch") twitch.push(v);
    else tiktok.push(v);
  });

  return featured.concat(twitter, partnerships, twitch, tiktok);
};

class EarnContent extends React.Component<Props | any, MyState> {
  state: MyState = { open: false, value: "" };

  componentDidMount(): void {
    const filter = { filter: { where: { username: getHostName() }, limit: 1 } };
    this.props.fetch(filter);

  }
  componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<MyState>,
    snapshot?: any
  ): void {
    if (this.props.assets.id != prevProps.assets.id) {
      // this.props.fetch(this.props.assets.id);
    }
  }

  render() {
    return (
      <div
        className="overflow-y-auto overflow-x-hidden px-1 signedout-tab lg:pb-[100px]"
        id="scrollbar">
        <motion.div
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.5 }}>
          {this.props.isFetching ? (
            <Loader height={30} width={30} white={true} />
          ) : (
            <div>
              {this.props.data &&
                sortBy(this.props.data || []).map((item, index) => {
                  return (
                    <div key={index}>
                      <div className="flex items-center justify-between mt-[20px] mb-5">
                        <div>
                          <p className="text-[#fff]/50 lg:text-[15px] text-[13px] uppercase font-normal tracking-wider">
                            {item.touchpoint.touchpoint}
                          </p>
                        </div>
                        {/* {socialTouchpoints().includes(
                          (item.touchpoint.touchpoint || "").toLowerCase()
                        ) && (
                          <button
                            disabled={!connect}
                            onClick={() =>
                              handleSocialAuth(
                                item.touchpoint.touchpoint,
                                this.props.user.token,
                                CallbackService.settings.id,
                                "fan"
                              )
                            }
                            className={` ${
                              connect
                                ? " border-primary primary"
                                : "border-gray-500 text-gray-500"
                            } w-[125px] flex items-center justify-center bg-transparent border-[1.5px]  rounded-full h-[39px] font-semibold text-[16px] cursor-pointer transition-all duration-700 ease-in-out`}>
                            {connect ? "Connect" : "Connected"}
                          </button>
                        )} */}
                      </div>

                      {(item.actionItems || []).map((actionItem, idex) => {
                        let redeemed = actionItem.redeemed || [];
                        let notRedeemed = actionItem.notRedeemed || [];
                        return (
                          <div key={item.touchpoint.touchpoint + idex}>
                            <EarnContentItem
                              notRedeemed={false}
                              actionItem={actionItem}
                              item={item.touchpoint}
                              user={this.props.user}
                              score_data={this.props.score_data}
                              creatorData={this.props.creatorData}
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
            </div>
          )}
        </motion.div>
      </div>
    );
  }
}

const mapStateToProps = ({ creator, user, score }) => {
  return {
    assets: creator.assets,
    data: creator.profile.data,
    isFetching: creator.profile.isFetching,
    user: user.user,
    creatorData: creator.data,
    score_data: score.data,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions: acreator } = require("@redux/CreatorRedux");
  return {
    ...stateProps,
    fetch: (data) => {
      acreator.fetchProfileData(dispatch, data);
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(EarnContent);
